module.exports = __webpack_public_path__ + "img/tab_button_img_mobile.06b39e98.png";